import { COLORS } from "./colors"
import { FONT_SIZES } from "./fonts"
import { RADII } from "./radii"
import { SIZES } from "./sizes"
import { SPACING } from "./spacing"
import { Z_INDEX } from "./z-index"
import { SHADOWS } from "@/theme/theme/shadows"

export * from "./breakpoints"
export * from "./colors"
export * from "./fonts"
export * from "./radii"
export * from "./sizes"
export * from "./spacing"
export * from "./z-index"

export const Theme = {
  COLORS,
  FONT_SIZES,
  RADII,
  SHADOWS,
  SIZES,
  SPACING,
  Z_INDEX,
}
